module.exports = __webpack_public_path__ + "img/bg.c6c016dd.png";